import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { CSSTransition } from 'react-transition-group';

import { useTranslation } from '@gem/modules/i18n';

import { useWaitingRoomToastPresenter } from './WaitingRoomToast.presenter';
import styles from './WaitingRoomToast.styles.m.css';

const ANIMATION_TIMEOUT = 250;

const itemTransition = {
  enter: styles.enter,
  enterActive: styles.enterActive,
  exit: styles.exit,
  exitActive: styles.exitActive,
};

export const WaitingRoomToast: FC = observer(() => {
  const { t } = useTranslation();
  const presenter = useWaitingRoomToastPresenter();

  return (
    <CSSTransition
      in={!!presenter.waitingRoomMembersCount && presenter.isWaitingRoomEnabled}
      classNames={itemTransition}
      timeout={ANIMATION_TIMEOUT}
      mountOnEnter
      unmountOnExit
    >
      <div className={styles.event}>
        <div className={styles.eventText}>
          {t('calls_waiting_room_have_request_message', { 0: presenter.waitingRoomMembersCount })}
        </div>
        {!presenter.isSidebarVisible ? (
          <button
            className={styles.eventButton}
            onClick={presenter.showMembers}
          >
            {t('common_view')}
          </button>
        ) : null}
      </div>
    </CSSTransition>
  );
});
